const getSenderIds = () => {
  return ["", "DSolar", "Soltell", "MySol365"];
};

export default getSenderIds;
